export type Query = Record<string, string | string[] | undefined>;

type QueryValue = string | number | boolean | null | undefined;
/** Query aceita na navegação (como o UrlObject do Next): valores não-string viram string. */
export type QueryInput = Record<string, QueryValue | readonly QueryValue[]>;
export type UrlObject = { pathname?: string | null; query?: QueryInput | null; hash?: string | null };
export type Url = string | UrlObject;

function toStrings(value: QueryValue | readonly QueryValue[]): string[] {
  const list = Array.isArray(value) ? value : [value];
  return list.filter((v): v is string | number | boolean => v !== null && v !== undefined).map(String);
}

/** Converte o href no formato do Next (pathname com [param] + query) em URL concreta. */
export function resolveHref(url: Url): string {
  if (typeof url === "string") return url;
  const rest: QueryInput = { ...(url.query ?? {}) };
  const pathname = (url.pathname ?? "").replace(/\[\[?(?:\.\.\.)?([^\]]+)\]\]?/g, (_, key: string) => {
    const values = toStrings(rest[key]);
    delete rest[key];
    return values.map(encodeURIComponent).join("/");
  });
  const search = new URLSearchParams();
  for (const [key, value] of Object.entries(rest)) {
    for (const v of toStrings(value)) search.append(key, v);
  }
  const qs = search.toString();
  const hash = url.hash ? `#${url.hash.replace(/^#/, "")}` : "";
  return `${pathname || window.location.pathname}${qs ? `?${qs}` : ""}${hash}`;
}
